export default [
  {
    path: '/myPatient',
    name: 'myPatient',
    meta: { title: '我的就诊人', keepAlive: true },
    component: () => import(/* webpackChunkName: "patient" */ '../views/patient/myPatient')
  },
  {
    path: '/addPatient',
    name: 'addPatient',
    meta: { title: '添加就诊人' },
    component: () => import(/* webpackChunkName: "patient" */ '../views/patient/addPatient')
  },
  {
    path: '/patientInfo',
    name: 'patientInfo',
    meta: { title: '就诊人详情' },
    component: () => import(/* webpackChunkName: "patient" */ '../views/patient/patientInfo')
  }
]
